// TODO @JstnMcBrd Make this auto-generated from the ISO 4217 standard
// cspell:disable

import Big from "big.js";

/**
 * Currencies from the ISO 4217 International Standard.
 * Last updated 2024-06-25. Retrieved 2024-08-05.
 * @see https://www.iso.org/iso-4217-currency-codes.html
 * @see https://www.six-group.com/dam/download/financial-information/data-center/iso-currrency/lists/list-one.xml
 */
export enum Currency {
  AED = "AED",
  AFN = "AFN",
  ALL = "ALL",
  AMD = "AMD",
  ANG = "ANG",
  AOA = "AOA",
  ARS = "ARS",
  AUD = "AUD",
  AWG = "AWG",
  AZN = "AZN",
  BAM = "BAM",
  BBD = "BBD",
  BDT = "BDT",
  BGN = "BGN",
  BHD = "BHD",
  BIF = "BIF",
  BMD = "BMD",
  BND = "BND",
  BOB = "BOB",
  BOV = "BOV",
  BRL = "BRL",
  BSD = "BSD",
  BTN = "BTN",
  BWP = "BWP",
  BYN = "BYN",
  BZD = "BZD",
  CAD = "CAD",
  CDF = "CDF",
  // CHE = "CHE", // IsFund="true"
  CHF = "CHF",
  // CHW = "CHW", // IsFund="true"
  // CLF = "CLF", // IsFund="true"
  CLP = "CLP",
  CNY = "CNY",
  COP = "COP",
  // COU = "COU", // IsFund="true"
  CRC = "CRC",
  CUC = "CUC",
  CUP = "CUP",
  CVE = "CVE",
  CZK = "CZK",
  DJF = "DJF",
  DKK = "DKK",
  DOP = "DOP",
  DZD = "DZD",
  EGP = "EGP",
  ERN = "ERN",
  ETB = "ETB",
  EUR = "EUR",
  FJD = "FJD",
  FKP = "FKP",
  GBP = "GBP",
  GEL = "GEL",
  GHS = "GHS",
  GIP = "GIP",
  GMD = "GMD",
  GNF = "GNF",
  GTQ = "GTQ",
  GYD = "GYD",
  HKD = "HKD",
  HNL = "HNL",
  HTG = "HTG",
  HUF = "HUF",
  IDR = "IDR",
  ILS = "ILS",
  INR = "INR",
  IQD = "IQD",
  IRR = "IRR",
  ISK = "ISK",
  JMD = "JMD",
  JOD = "JOD",
  JPY = "JPY",
  KES = "KES",
  KGS = "KGS",
  KHR = "KHR",
  KMF = "KMF",
  KPW = "KPW",
  KRW = "KRW",
  KWD = "KWD",
  KYD = "KYD",
  KZT = "KZT",
  LAK = "LAK",
  LBP = "LBP",
  LKR = "LKR",
  LRD = "LRD",
  LSL = "LSL",
  LYD = "LYD",
  MAD = "MAD",
  MDL = "MDL",
  MGA = "MGA",
  MKD = "MKD",
  MMK = "MMK",
  MNT = "MNT",
  MOP = "MOP",
  MRU = "MRU",
  MUR = "MUR",
  MVR = "MVR",
  MWK = "MWK",
  MXN = "MXN",
  // MXV = "MXV", // IsFund="true"
  MYR = "MYR",
  MZN = "MZN",
  NAD = "NAD",
  NGN = "NGN",
  NIO = "NIO",
  NOK = "NOK",
  NPR = "NPR",
  NZD = "NZD",
  OMR = "OMR",
  PAB = "PAB",
  PEN = "PEN",
  PGK = "PGK",
  PHP = "PHP",
  PKR = "PKR",
  PLN = "PLN",
  PYG = "PYG",
  QAR = "QAR",
  RON = "RON",
  RSD = "RSD",
  RUB = "RUB",
  RWF = "RWF",
  SAR = "SAR",
  SBD = "SBD",
  SCR = "SCR",
  SDG = "SDG",
  SEK = "SEK",
  SGD = "SGD",
  SHP = "SHP",
  SLE = "SLE",
  SOS = "SOS",
  SRD = "SRD",
  SSP = "SSP",
  STN = "STN",
  SVC = "SVC",
  SYP = "SYP",
  SZL = "SZL",
  THB = "THB",
  TJS = "TJS",
  TMT = "TMT",
  TND = "TND",
  TOP = "TOP",
  TRY = "TRY",
  TTD = "TTD",
  TWD = "TWD",
  TZS = "TZS",
  UAH = "UAH",
  UGX = "UGX",
  USD = "USD",
  // USN = "USN", // IsFund="true"
  // UYI = "UYI", // IsFund="true"
  UYU = "UYU",
  UYW = "UYW",
  UZS = "UZS",
  VED = "VED",
  VES = "VES",
  VND = "VND",
  VUV = "VUV",
  WST = "WST",
  XAF = "XAF",
  XAG = "XAG",
  XAU = "XAU",
  XBA = "XBA",
  XBB = "XBB",
  XBC = "XBC",
  XBD = "XBD",
  XCD = "XCD",
  XDR = "XDR",
  XOF = "XOF",
  XPD = "XPD",
  XPF = "XPF",
  XPT = "XPT",
  XSU = "XSU",
  XTS = "XTS",
  XUA = "XUA",
  XXX = "XXX",
  YER = "YER",
  ZAR = "ZAR",
  ZMW = "ZMW",
  ZWG = "ZWG",
  ZWL = "ZWL",
  // Older currencies not in the ISO 4217 International Standard but still used by Shopify (as of 2025-09-24)
  BYR = "BYR",
  HRK = "HRK",
  JEP = "JEP",
  KID = "KID",
  LTL = "LTL",
  LVL = "LVL",
  SLL = "SLL",
  STD = "STD",
  USDC = "USDC",
  VEF = "VEF",
}

/**
 * List of currencies in the ISO 4217 International Standard
 * @see Currency
 */
export const CURRENCIES = Object.values(Currency);
const CURRENCIES_SET = new Set(CURRENCIES);

/** @returns Whether the given string is a valid currency code */
export function isCurrency(code: string): code is Currency {
  return (CURRENCIES_SET as Set<string>).has(code);
}

/** Currency names from the ISO 4217 International Standard */
export const CurrencyNames = {
  [Currency.AED]: "UAE Dirham",
  [Currency.AFN]: "Afghani",
  [Currency.ALL]: "Lek",
  [Currency.AMD]: "Armenian Dram",
  [Currency.ANG]: "Netherlands Antillean Guilder",
  [Currency.AOA]: "Kwanza",
  [Currency.ARS]: "Argentine Peso",
  [Currency.AUD]: "Australian Dollar",
  [Currency.AWG]: "Aruban Florin",
  [Currency.AZN]: "Azerbaijan Manat",
  [Currency.BAM]: "Convertible Mark",
  [Currency.BBD]: "Barbados Dollar",
  [Currency.BDT]: "Taka",
  [Currency.BGN]: "Bulgarian Lev",
  [Currency.BHD]: "Bahraini Dinar",
  [Currency.BIF]: "Burundi Franc",
  [Currency.BMD]: "Bermudian Dollar",
  [Currency.BND]: "Brunei Dollar",
  [Currency.BOB]: "Boliviano",
  [Currency.BOV]: "Mvdol",
  [Currency.BRL]: "Brazilian Real",
  [Currency.BSD]: "Bahamian Dollar",
  [Currency.BTN]: "Ngultrum",
  [Currency.BWP]: "Pula",
  [Currency.BYN]: "Belarusian Ruble",
  [Currency.BZD]: "Belize Dollar",
  [Currency.CAD]: "Canadian Dollar",
  [Currency.CDF]: "Congolese Franc",
  [Currency.CHF]: "Swiss Franc",
  // [Currency.CHE]: "WIR Euro",
  // [Currency.CHW]: "WIR Franc",
  // [Currency.CLF]: "Unidad de Fomento",
  [Currency.CLP]: "Chilean Peso",
  [Currency.CNY]: "Yuan Renminbi",
  [Currency.COP]: "Colombian Peso",
  // [Currency.COU]: "Unidad de Valor Real",
  [Currency.CRC]: "Costa Rican Colon",
  [Currency.CUC]: "Peso Convertible",
  [Currency.CUP]: "Cuban Peso",
  [Currency.CVE]: "Cabo Verde Escudo",
  [Currency.CZK]: "Czech Koruna",
  [Currency.DJF]: "Djibouti Franc",
  [Currency.DKK]: "Danish Krone",
  [Currency.DOP]: "Dominican Peso",
  [Currency.DZD]: "Algerian Dinar",
  [Currency.EGP]: "Egyptian Pound",
  [Currency.ERN]: "Nakfa",
  [Currency.ETB]: "Ethiopian Birr",
  [Currency.EUR]: "Euro",
  [Currency.FJD]: "Fiji Dollar",
  [Currency.FKP]: "Falkland Islands Pound",
  [Currency.GBP]: "Pound Sterling",
  [Currency.GEL]: "Lari",
  [Currency.GHS]: "Ghana Cedi",
  [Currency.GIP]: "Gibraltar Pound",
  [Currency.GMD]: "Dalasi",
  [Currency.GNF]: "Guinean Franc",
  [Currency.GTQ]: "Quetzal",
  [Currency.GYD]: "Guyana Dollar",
  [Currency.HKD]: "Hong Kong Dollar",
  [Currency.HNL]: "Lempira",
  [Currency.HTG]: "Gourde",
  [Currency.HUF]: "Forint",
  [Currency.IDR]: "Rupiah",
  [Currency.ILS]: "New Israeli Sheqel",
  [Currency.INR]: "Indian Rupee",
  [Currency.IQD]: "Iraqi Dinar",
  [Currency.IRR]: "Iranian Rial",
  [Currency.ISK]: "Iceland Krona",
  [Currency.JMD]: "Jamaican Dollar",
  [Currency.JOD]: "Jordanian Dinar",
  [Currency.JPY]: "Yen",
  [Currency.KES]: "Kenyan Shilling",
  [Currency.KGS]: "Som",
  [Currency.KHR]: "Riel",
  [Currency.KMF]: "Comorian Franc ",
  [Currency.KPW]: "North Korean Won",
  [Currency.KRW]: "Won",
  [Currency.KWD]: "Kuwaiti Dinar",
  [Currency.KYD]: "Cayman Islands Dollar",
  [Currency.KZT]: "Tenge",
  [Currency.LAK]: "Lao Kip",
  [Currency.LBP]: "Lebanese Pound",
  [Currency.LKR]: "Sri Lanka Rupee",
  [Currency.LRD]: "Liberian Dollar",
  [Currency.LSL]: "Loti",
  [Currency.LYD]: "Libyan Dinar",
  [Currency.MAD]: "Moroccan Dirham",
  [Currency.MDL]: "Moldovan Leu",
  [Currency.MGA]: "Malagasy Ariary",
  [Currency.MKD]: "Denar",
  [Currency.MMK]: "Kyat",
  [Currency.MNT]: "Tugrik",
  [Currency.MOP]: "Pataca",
  [Currency.MRU]: "Ouguiya",
  [Currency.MUR]: "Mauritius Rupee",
  [Currency.MVR]: "Rufiyaa",
  [Currency.MWK]: "Malawi Kwacha",
  [Currency.MXN]: "Mexican Peso",
  // [Currency.MXV]: "Mexican Unidad de Inversion (UDI)",
  [Currency.MYR]: "Malaysian Ringgit",
  [Currency.MZN]: "Mozambique Metical",
  [Currency.NAD]: "Namibia Dollar",
  [Currency.NGN]: "Naira",
  [Currency.NIO]: "Cordoba Oro",
  [Currency.NOK]: "Norwegian Krone",
  [Currency.NPR]: "Nepalese Rupee",
  [Currency.NZD]: "New Zealand Dollar",
  [Currency.OMR]: "Rial Omani",
  [Currency.PAB]: "Balboa",
  [Currency.PEN]: "Sol",
  [Currency.PGK]: "Kina",
  [Currency.PHP]: "Philippine Peso",
  [Currency.PKR]: "Pakistan Rupee",
  [Currency.PLN]: "Zloty",
  [Currency.PYG]: "Guarani",
  [Currency.QAR]: "Qatari Rial",
  [Currency.RON]: "Romanian Leu",
  [Currency.RSD]: "Serbian Dinar",
  [Currency.RUB]: "Russian Ruble",
  [Currency.RWF]: "Rwanda Franc",
  [Currency.SAR]: "Saudi Riyal",
  [Currency.SBD]: "Solomon Islands Dollar",
  [Currency.SCR]: "Seychelles Rupee",
  [Currency.SDG]: "Sudanese Pound",
  [Currency.SEK]: "Swedish Krona",
  [Currency.SGD]: "Singapore Dollar",
  [Currency.SHP]: "Saint Helena Pound",
  [Currency.SLE]: "Leone",
  [Currency.SOS]: "Somali Shilling",
  [Currency.SRD]: "Surinam Dollar",
  [Currency.SSP]: "South Sudanese Pound",
  [Currency.STN]: "Dobra",
  [Currency.SVC]: "El Salvador Colon",
  [Currency.SYP]: "Syrian Pound",
  [Currency.SZL]: "Lilangeni",
  [Currency.THB]: "Baht",
  [Currency.TJS]: "Somoni",
  [Currency.TMT]: "Turkmenistan New Manat",
  [Currency.TND]: "Tunisian Dinar",
  [Currency.TOP]: "Pa'anga",
  [Currency.TRY]: "Turkish Lira",
  [Currency.TTD]: "Trinidad and Tobago Dollar",
  [Currency.TWD]: "New Taiwan Dollar",
  [Currency.TZS]: "Tanzanian Shilling",
  [Currency.UAH]: "Hryvnia",
  [Currency.UGX]: "Uganda Shilling",
  [Currency.USD]: "US Dollar",
  // [Currency.USN]: "US Dollar (Next day)",
  // [Currency.UYI]: "Uruguay Peso en Unidades Indexadas (URUIURUI)",
  [Currency.UYU]: "Peso Uruguayo",
  [Currency.UYW]: "Unidad Previsional",
  [Currency.UZS]: "Uzbekistan Sum",
  [Currency.VED]: "Bolívar Soberano",
  [Currency.VES]: "Bolívar Soberano",
  [Currency.VND]: "Dong",
  [Currency.VUV]: "Vatu",
  [Currency.WST]: "Tala",
  [Currency.XAF]: "CFA Franc BEAC",
  [Currency.XAG]: "Silver",
  [Currency.XAU]: "Gold",
  [Currency.XBA]: "Bond Markets Unit European Composite Unit (EURCO)",
  [Currency.XBB]: "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
  [Currency.XBC]: "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
  [Currency.XBD]: "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
  [Currency.XCD]: "East Caribbean Dollar",
  [Currency.XDR]: "SDR (Special Drawing Right)",
  [Currency.XOF]: "CFA Franc BCEAO",
  [Currency.XPD]: "Palladium",
  [Currency.XPF]: "CFP Franc",
  [Currency.XPT]: "Platinum",
  [Currency.XSU]: "Sucre",
  [Currency.XTS]: "Codes specifically reserved for testing purposes",
  [Currency.XUA]: "ADB Unit of Account",
  [Currency.XXX]:
    "The codes assigned for transactions where no currency is involved",
  [Currency.YER]: "Yemeni Rial",
  [Currency.ZAR]: "Rand",
  [Currency.ZMW]: "Zambian Kwacha",
  [Currency.ZWG]: "Zimbabwe Gold",
  [Currency.ZWL]: "Zimbabwe Dollar",
  // Older currencies not in the ISO 4217 International Standard but still used by Shopify (as of 2025-09-24)
  [Currency.BYR]: "Belarusian Ruble",
  [Currency.HRK]: "Croatian Kuna",
  [Currency.JEP]: "Jersey Pound",
  [Currency.KID]: "Kiribati Dollar",
  [Currency.LTL]: "Lithuanian Litas",
  [Currency.LVL]: "Latvian Lats",
  [Currency.SLL]: "Sierra Leonean Leone",
  [Currency.STD]: "São Tomé and Príncipe Dobra",
  [Currency.USDC]: "USD Coin",
  [Currency.VEF]: "Venezuelan Bolívar Fuerte",
} as const satisfies { [K in Currency]: string };

/**
 * Currency minor units from the ISO 4217 International Standard.
 * Currencies with no smallest unit are marked as "null".
 */
export const CurrencyMinorUnits = {
  [Currency.AED]: 2,
  [Currency.AFN]: 2,
  [Currency.ALL]: 2,
  [Currency.AMD]: 2,
  [Currency.ANG]: 2,
  [Currency.AOA]: 2,
  [Currency.ARS]: 2,
  [Currency.AUD]: 2,
  [Currency.AWG]: 2,
  [Currency.AZN]: 2,
  [Currency.BAM]: 2,
  [Currency.BBD]: 2,
  [Currency.BDT]: 2,
  [Currency.BGN]: 2,
  [Currency.BHD]: 3,
  [Currency.BIF]: 0,
  [Currency.BMD]: 2,
  [Currency.BND]: 2,
  [Currency.BOB]: 2,
  [Currency.BOV]: 2,
  [Currency.BRL]: 2,
  [Currency.BSD]: 2,
  [Currency.BTN]: 2,
  [Currency.BWP]: 2,
  [Currency.BYN]: 2,
  [Currency.BZD]: 2,
  [Currency.CAD]: 2,
  [Currency.CDF]: 2,
  // [Currency.CHE]: 2,
  [Currency.CHF]: 2,
  // [Currency.CHW]: 2,
  // [Currency.CLF]: 4,
  [Currency.CLP]: 0,
  [Currency.CNY]: 2,
  [Currency.COP]: 2,
  // [Currency.COU]: 2,
  [Currency.CRC]: 2,
  [Currency.CUC]: 2,
  [Currency.CUP]: 2,
  [Currency.CVE]: 2,
  [Currency.CZK]: 2,
  [Currency.DJF]: 0,
  [Currency.DKK]: 2,
  [Currency.DOP]: 2,
  [Currency.DZD]: 2,
  [Currency.EGP]: 2,
  [Currency.ERN]: 2,
  [Currency.ETB]: 2,
  [Currency.EUR]: 2,
  [Currency.FJD]: 2,
  [Currency.FKP]: 2,
  [Currency.GBP]: 2,
  [Currency.GEL]: 2,
  [Currency.GHS]: 2,
  [Currency.GIP]: 2,
  [Currency.GMD]: 2,
  [Currency.GNF]: 0,
  [Currency.GTQ]: 2,
  [Currency.GYD]: 2,
  [Currency.HKD]: 2,
  [Currency.HNL]: 2,
  [Currency.HTG]: 2,
  [Currency.HUF]: 2,
  [Currency.IDR]: 2,
  [Currency.ILS]: 2,
  [Currency.INR]: 2,
  [Currency.IQD]: 3,
  [Currency.IRR]: 2,
  [Currency.ISK]: 0,
  [Currency.JMD]: 2,
  [Currency.JOD]: 3,
  [Currency.JPY]: 0,
  [Currency.KES]: 2,
  [Currency.KGS]: 2,
  [Currency.KHR]: 2,
  [Currency.KMF]: 0,
  [Currency.KPW]: 2,
  [Currency.KRW]: 0,
  [Currency.KWD]: 3,
  [Currency.KYD]: 2,
  [Currency.KZT]: 2,
  [Currency.LAK]: 2,
  [Currency.LBP]: 2,
  [Currency.LKR]: 2,
  [Currency.LRD]: 2,
  [Currency.LSL]: 2,
  [Currency.LYD]: 3,
  [Currency.MAD]: 2,
  [Currency.MDL]: 2,
  [Currency.MGA]: 2,
  [Currency.MKD]: 2,
  [Currency.MMK]: 2,
  [Currency.MNT]: 2,
  [Currency.MOP]: 2,
  [Currency.MRU]: 2,
  [Currency.MUR]: 2,
  [Currency.MVR]: 2,
  [Currency.MWK]: 2,
  [Currency.MXN]: 2,
  // [Currency.MXV]: 2,
  [Currency.MYR]: 2,
  [Currency.MZN]: 2,
  [Currency.NAD]: 2,
  [Currency.NGN]: 2,
  [Currency.NIO]: 2,
  [Currency.NOK]: 2,
  [Currency.NPR]: 2,
  [Currency.NZD]: 2,
  [Currency.OMR]: 3,
  [Currency.PAB]: 2,
  [Currency.PEN]: 2,
  [Currency.PGK]: 2,
  [Currency.PHP]: 2,
  [Currency.PKR]: 2,
  [Currency.PLN]: 2,
  [Currency.PYG]: 0,
  [Currency.QAR]: 2,
  [Currency.RON]: 2,
  [Currency.RSD]: 2,
  [Currency.RUB]: 2,
  [Currency.RWF]: 0,
  [Currency.SAR]: 2,
  [Currency.SBD]: 2,
  [Currency.SCR]: 2,
  [Currency.SDG]: 2,
  [Currency.SEK]: 2,
  [Currency.SGD]: 2,
  [Currency.SHP]: 2,
  [Currency.SLE]: 2,
  [Currency.SOS]: 2,
  [Currency.SRD]: 2,
  [Currency.SSP]: 2,
  [Currency.STN]: 2,
  [Currency.SVC]: 2,
  [Currency.SYP]: 2,
  [Currency.SZL]: 2,
  [Currency.THB]: 2,
  [Currency.TJS]: 2,
  [Currency.TMT]: 2,
  [Currency.TND]: 3,
  [Currency.TOP]: 2,
  [Currency.TRY]: 2,
  [Currency.TTD]: 2,
  [Currency.TWD]: 2,
  [Currency.TZS]: 2,
  [Currency.UAH]: 2,
  [Currency.UGX]: 0,
  [Currency.USD]: 2,
  // [Currency.USN]: 2,
  // [Currency.UYI]: 0,
  [Currency.UYU]: 2,
  [Currency.UYW]: 4,
  [Currency.UZS]: 2,
  [Currency.VED]: 2,
  [Currency.VES]: 2,
  [Currency.VND]: 0,
  [Currency.VUV]: 0,
  [Currency.WST]: 2,
  [Currency.XAF]: 0,
  [Currency.XAG]: null,
  [Currency.XAU]: null,
  [Currency.XBA]: null,
  [Currency.XBB]: null,
  [Currency.XBC]: null,
  [Currency.XBD]: null,
  [Currency.XCD]: 2,
  [Currency.XDR]: null,
  [Currency.XOF]: 0,
  [Currency.XPD]: null,
  [Currency.XPF]: 0,
  [Currency.XPT]: null,
  [Currency.XSU]: null,
  [Currency.XTS]: null,
  [Currency.XUA]: null,
  [Currency.XXX]: null,
  [Currency.YER]: 2,
  [Currency.ZAR]: 2,
  [Currency.ZMW]: 2,
  [Currency.ZWG]: 2,
  [Currency.ZWL]: 2,
  // Older currencies not in the ISO 4217 International Standard but still used by Shopify (as of 2025-09-24)
  [Currency.BYR]: 0,
  [Currency.HRK]: 2,
  [Currency.JEP]: 2,
  [Currency.KID]: 2,
  [Currency.LTL]: 2,
  [Currency.LVL]: 2,
  [Currency.SLL]: 2,
  [Currency.STD]: 2,
  [Currency.USDC]: 2,
  [Currency.VEF]: 2,
} as const satisfies { [K in Currency]: number | null };

// TODO @JstnMcBrd It could also be possible to extract which countries use which currencies from the ISO 4217 International Standard

/**
 * Minor-unit count for a currency, tolerant of case and unknown codes. String
 * codes are upper-cased before the lookup so a lower-case code (e.g. `'jpy'`)
 * can't silently fall through to the 2-decimal default and mis-scale money;
 * unknown codes fall back to 2. Shared by the major/minor conversion helpers
 * below so they all normalize identically.
 */
function minorUnitsForCurrency(currency: Currency | string): number {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  const key = (
    typeof currency === "string" ? currency.toUpperCase() : currency
  ) as Currency;
  return CurrencyMinorUnits[key] ?? 2;
}

/**
 * E.g. 17.25 -> 1725 cents
 * @param charge - The charge amount in major units (e.g. 5 dollars & 25 cents would be "5.25")
 */
export function amountToMinorUnits(
  amount: string | number | Big.Big,
  currency: Currency | string = Currency.USD,
): number {
  return parseInt(
    Big(amount)
      .times(10 ** minorUnitsForCurrency(currency))
      .toFixed(0),
  );
}

/**
 * E.g. 1725 cents -> 17.25
 * @param minorUnits - The amount in minor units (e.g. 1725 cents)
 * @param currency - The currency code (defaults to USD)
 */
export function minorUnitsToAmount(
  minorUnits: string | number | Big.Big | bigint,
  currency: Currency | string = Currency.USD,
): number {
  const decimals = minorUnitsForCurrency(currency);
  return parseFloat(
    Big(minorUnits.toString())
      .div(10 ** decimals)
      .toFixed(decimals),
  );
}

/**
 * Like {@link minorUnitsToAmount}, but returns the exact major-amount decimal
 * string instead of a float. Use this when serializing money for an external
 * system that must receive the exact amount (e.g. a Shopify price list): a
 * bigint minor amount beyond Number's 2^53 integer-precision limit survives
 * here, whereas the `parseFloat` in `minorUnitsToAmount` would corrupt it.
 *
 * Unknown codes fall back to 2 minor units; lower-case codes are normalized
 * (see {@link minorUnitsForCurrency}) so they can't silently mis-scale.
 *
 * E.g. 12345 USD minor -> "123.45"; 1000 JPY minor -> "1000".
 */
export function minorUnitsToAmountString(
  minorUnits: string | number | Big.Big | bigint,
  currency: Currency | string = Currency.USD,
): string {
  const decimals = minorUnitsForCurrency(currency);
  return Big(minorUnits.toString())
    .div(10 ** decimals)
    .toFixed(decimals);
}

/**
 * E.g. 1.2345 -> 12345
 * @param amount - The charge amount in major units (e.g. 5 dollars & 25 cents would be "5.25")
 * @param currency - The currency code (defaults to USD)
 * @param fractionalDigits - The number of additional fractional digits to support (defaults to 2)
 */
export function amountToMinorFractionalUnits(
  amount: string | number | Big.Big,
  currency: Currency | string = Currency.USD,
  fractionalDigits = 2,
): number {
  const minorFractionalUnits =
    minorUnitsForCurrency(currency) + fractionalDigits;
  return parseInt(
    Big(amount)
      .times(10 ** minorFractionalUnits)
      .toFixed(0),
  );
}

/**
 * E.g. 12345 cents -> 1.2345
 * @param minorUnits - The amount in minor fractional units (e.g. 12345 fractional cents)
 * @param currency - The currency code (defaults to USD)
 * @param fractionalDigits - The number of fractional digits (defaults to 2)
 */
export function minorFractionalUnitsToAmount(
  minorUnits: string | number | Big.Big | bigint,
  currency: Currency | string = Currency.USD,
  fractionalDigits = 2,
): number {
  const minorFractionalUnits =
    minorUnitsForCurrency(currency) + fractionalDigits;
  return parseFloat(
    Big(minorUnits.toString())
      .div(10 ** minorFractionalUnits)
      .toFixed(minorFractionalUnits),
  );
}

/**
 * Like {@link minorFractionalUnitsToAmount}, but returns the exact major-amount
 * decimal string instead of a float — the fractional-precision counterpart to
 * {@link minorUnitsToAmountString}. E.g. 456789 USD minor-fractional (4 dp) ->
 * "45.6789".
 */
export function minorFractionalUnitsToAmountString(
  minorUnits: string | number | Big.Big | bigint,
  currency: Currency | string = Currency.USD,
  fractionalDigits = 2,
): string {
  const minorFractionalUnits =
    minorUnitsForCurrency(currency) + fractionalDigits;
  return Big(minorUnits.toString())
    .div(10 ** minorFractionalUnits)
    .toFixed(minorFractionalUnits);
}

export function stringToCurrency(code: string): Currency {
  if (!isCurrency(code)) {
    throw new Error(`Invalid currency code: ${code}`);
  }

  return code;
}
